

const linkify = (text) => {
    if (!text) return '';

    const urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;

    return text.replace(urlRegex, function(url,b,c) {
        let url2 = (c == 'www.') ?  'http://' +url : url;
        return '<a class="nuxt-link-active" href="' +url2+ '" target="_blank">' + url + '</a>';
    });
};



import { defineNuxtPlugin } from '#app';

export default defineNuxtPlugin((nuxtApp) => {


    // and as `const { set } = useNuxtApp()` in <script setup>
    nuxtApp.provide('linkify', linkify);
});